import React from 'react';
import { DollarSign, Package, CreditCard, Building2 } from 'lucide-react';
import SuccessRateCard from './SuccessRateCard';

function SummaryStats({ deliveries, successStats }) {
  // Calculate financial statistics
  const totalCashCollected = deliveries.reduce((sum, d) => sum + (d.charged || 0), 0);
  const deliveriesWithCash = deliveries.filter(d => d.charged && d.charged > 0).length;
  const fastmaxTransfers = deliveries.filter(d => d.fastmax_transfer_amount && d.fastmax_transfer_amount > 0).length;
  const providerTransfers = deliveries.filter(d => d.provider_transfer_amount && d.provider_transfer_amount > 0).length;
  const totalFastmaxAmount = deliveries.reduce((sum, d) => sum + (d.fastmax_transfer_amount || 0), 0);
  const totalProviderAmount = deliveries.reduce((sum, d) => sum + (d.provider_transfer_amount || 0), 0);

  const stats = [
    {
      label: 'Efectivo Cobrado',
      value: `S/ ${totalCashCollected.toFixed(2)}`,
      count: `${deliveriesWithCash} entregas`,
      icon: DollarSign,
      bgColor: 'bg-brand-primary',
      iconColor: 'text-white',
    },
    {
      label: 'Total Entregas',
      value: deliveries.length,
      count: 'completadas',
      icon: Package,
      bgColor: 'bg-brand-green',
      iconColor: 'text-white',
    },
    {
      label: 'Transfer FastMax',
      value: `S/ ${totalFastmaxAmount.toFixed(2)}`,
      count: `${fastmaxTransfers} entregas`,
      icon: CreditCard,
      bgColor: 'bg-brand-gold',
      iconColor: 'text-white',
    },
    {
      label: 'Transfer Proveedor',
      value: `S/ ${totalProviderAmount.toFixed(2)}`,
      count: `${providerTransfers} entregas`,
      icon: Building2,
      bgColor: 'bg-gray-600',
      iconColor: 'text-white',
    },
  ];

  return (
    <div className="mb-6">
      <h2 className="text-lg font-bold text-gray-800 mb-3 font-montserrat">
        Resumen General
      </h2>
      <div className="grid grid-cols-2 gap-3">
        {stats.map((stat, index) => (
          <div
            key={index}
            className="bg-white rounded-lg shadow-sm border border-gray-200 p-4"
          >
            <div className="flex items-start justify-between mb-2">
              <div className={`${stat.bgColor} ${stat.iconColor} p-2 rounded-lg`}>
                <stat.icon className="w-5 h-5" />
              </div>
            </div>
            <p className="text-xs text-gray-600 mb-1">{stat.label}</p>
            <p className="text-xl font-bold text-gray-900 mb-1">
              {stat.value}
            </p>
            <p className="text-xs text-gray-500">{stat.count}</p>
          </div>
        ))}

        {/* Success Rate Card — spans full width (col-span-2 is set inside the card) */}
        <SuccessRateCard successStats={successStats} />
      </div>

      {/* Total to Deposit - Prominent Display */}
      <div className="mt-4 bg-gradient-to-r from-brand-primary to-pink-600 rounded-lg shadow-lg p-5 text-white">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-sm opacity-90 mb-1">Total a Depositar</p>
            <p className="text-3xl font-bold font-montserrat">
              S/ {totalCashCollected.toFixed(2)}
            </p>
          </div>
          <div className="bg-white/20 p-3 rounded-full">
            <DollarSign className="w-8 h-8" />
          </div>
        </div>
      </div>
    </div>
  );
}

export default SummaryStats;